var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 7.27757L1.52852 11.7491C1.36122 11.9164 1.14829 12 0.889734 12C0.631179 12 0.418251 11.9164 0.250951 11.7491C0.0836502 11.5817 0 11.3688 0 11.1103C0 10.8517 0.0836502 10.6388 0.250951 10.4715L4.72243 6L0.250951 1.52852C0.0836502 1.36122 0 1.14829 0 0.889734C0 0.631179 0.0836502 0.418251 0.250951 0.250951C0.418251 0.0836502 0.631179 0 0.889734 0C1.14829 0 1.36122 0.0836502 1.52852 0.250951L6 4.72243L10.4715 0.250951C10.6388 0.0836502 10.8517 0 11.1103 0C11.3688 0 11.5817 0.0836502 11.7491 0.250951C11.9164 0.418251 12 0.631179 12 0.889734C12 1.14829 11.9164 1.36122 11.7491 1.52852L7.27757 6L11.7491 10.4715C11.9164 10.6388 12 10.8517 12 11.1103C12 11.3688 11.9164 11.5817 11.7491 11.7491C11.5817 11.9164 11.3688 12 11.1103 12C10.8517 12 10.6388 11.9164 10.4715 11.7491L6 7.27757Z",
    fill: "#27282B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseicon);
export default __webpack_public_path__ + "static/media/closeicon.3bae0f84ba47b54c38a466ae7234307d.svg";
export { ForwardRef as ReactComponent };